export default __webpack_public_path__ + "static/media/special-icon-active.b5a9084a.webp";